<ng-template #level let-items>
  <ul class="preview-list">
    @for (node of items; track node.id) {
      <li>
        <span class="preview-name">{{ node.name }}</span>
        @if (node.children.length) {
          <ng-container *ngTemplateOutlet="level; context: { $implicit: node.children }"></ng-container>
        }
      </li>
    }
  </ul>
</ng-template>

<div class="preview-root">
  <ng-container *ngTemplateOutlet="level; context: { $implicit: nodes() }"></ng-container>
</div>
